import React, { useEffect, useState } from 'react';
import { useCommands } from '../api/commands';
import { useNavigate } from 'react-router-dom';
import PageHeader from '../components/PageHeader';

export default function Services(){
  const cmd = useCommands();
  const nav = useNavigate();

  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  async function load(){
    setLoading(true); setError('');
    try{
      const list = await cmd.call ? [] : []; // placeholder if you don't expose services in commands
      // If commands.js exposes GPM services: await cmd.services.list()
      const data = await cmd.api?.get?.('/gpm/services').then(r=>r.data).catch(()=>[]);
      setRows(Array.isArray(data) ? data : []);
    }catch(e){
      setError(e?.response?.data?.error || e?.message || 'Failed to load services');
    }finally{ setLoading(false); }
  }
  useEffect(()=>{ load(); }, []);

  return (
    <div className="container">
      <PageHeader
        eyebrow="GPM"
        title="Services"
        actions={
          <>
            <button className="btn secondary" onClick={()=>nav('/dashboard')}>Back</button>
            <button className="btn secondary" onClick={load}>Reload</button>
          </>
        }
      />

      {error && <div className="page-alerts"><div className="alert error">{error}</div></div>}

      <div className="card">
        {loading ? <div className="empty">Loading</div> : rows.length===0 ? (
          <div className="empty">No services.</div>
        ) : (
          <div className="table-wrap">
            <table className="table">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Description</th>
                </tr>
              </thead>
              <tbody>
                {rows.map((s, i)=>(
                  <tr key={s.id || s.name || i}>
                    <td className="cell-strong">{s.name || '—'}</td>
                    <td>{s.description || '—'}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
